import React from 'react';

const Mobile = ({ fill = '#6B6C7B' }: { fill?: string }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0.75H6C5.40326 0.75 4.83097 0.987053 4.40901 1.40901C3.98705 1.83097 3.75 2.40326 3.75 3V15C3.75 15.5967 3.98705 16.169 4.40901 16.591C4.83097 17.0129 5.40326 17.25 6 17.25H12C12.5967 17.25 13.169 17.0129 13.591 16.591C14.0129 16.169 14.25 15.5967 14.25 15V3C14.25 2.40326 14.0129 1.83097 13.591 1.40901C13.169 0.987053 12.5967 0.75 12 0.75ZM10.125 15.75H7.875C7.77554 15.75 7.68016 15.7105 7.60983 15.6402C7.53951 15.5698 7.5 15.4745 7.5 15.375C7.5 15.2755 7.53951 15.1802 7.60983 15.1098C7.68016 15.0395 7.77554 15 7.875 15H10.125C10.2245 15 10.3198 15.0395 10.3902 15.1098C10.4605 15.1802 10.5 15.2755 10.5 15.375C10.5 15.4745 10.4605 15.5698 10.3902 15.6402C10.3198 15.7105 10.2245 15.75 10.125 15.75ZM12.75 13.5H5.25V3H12.75V13.5Z"
      fill={fill}
    />
  </svg>
);

export default Mobile;
